export default {
  sessionId: null,
  allAgents: [],
  agents: [],
  deviceToken: '',
  answers: [],
  errors: null
};
